import { VerificationStatus } from "shared/types";
import { EmptyCellIcon } from "./TableBodySections/components/EmptyCellIcon";

export const CanadianCreditReportStatus = ({
  status,
  score
}: {
  status: VerificationStatus;
  score?: number | string | null;
}) => {
  if (status === VerificationStatus.Skipped)
    return (
      <p className="text-content-200 text-sm font-medium">
        Wasn&apos;t a Canadian resident
      </p>
    );

  if (status === VerificationStatus.Finished)
    return (
      <p className="text-content-1000 text-sm font-medium">
        {score != null ? String(score) : "Done"}
      </p>
    );

  return <EmptyCellIcon />;
};
